export const shadows = {
    '1dp': '0px 1px 2px rgba(0, 0, 0, 0.24), 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.16)',
    '2dp': '0px 1px 8px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.16)',
    '4dp': '0px 1px 12px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.02), 0px 1px 4px rgba(0, 0, 0, 0.01)',
    '6dp': '0px 1px 12px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.08), 0px 3px 6px rgba(0, 0, 0, 0.1)',
    '8dp': '0px 1px 16px rgba(0, 0, 0, 0.12), 0px 6px 12px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.12)',
    '12dp': '0px 1px 24px rgba(0, 0, 0, 0.12), 0px 8px 16px rgba(0, 0, 0, 0.12), 0px 6px 12px rgba(0, 0, 0, 0.12)',
    '16dp': '0px 0px 52px rgba(0, 0, 0, 0.16), 0px 0px 28px rgba(0, 0, 0, 0.16), 0px 0px 18px rgba(0, 0, 0, 0.16)',
    '16dpModal': '0px 1px 32px rgba(0, 0, 0, 0.12), 0px 12px 24px rgba(0, 0, 0, 0.12), 0px 8px 16px rgba(0, 0, 0, 0.12)',
    '24dp': '0px 1px 48px rgba(0, 0, 0, 0.12), 0px 16px 32px rgba(0, 0, 0, 0.12), 0px 12px 24px rgba(0, 0, 0, 0.12)',
};
export default shadows;
